
import { get, post } from '../utils/http'

export const fetchELiterature = (id) => {
  return get('ELITERATURE_FETCH', `/admin/org/${id}/eliterature`);
}

export const save = (orgId, selectedSbl) => {

  let form = new FormData();

  form.append('orgId', orgId);
  form.append('selectedSbl', selectedSbl);

  return post('ELITERATURE_SAVE', '/admin/eliterature/update', form);
}



// WEBPACK FOOTER //
// ./src/eliterature/eliteratureActions.js